module.exports = __webpack_public_path__ + "static/media/member11.ecea5fa1.jpg";